import React, {Component} from "react"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import {Row, Col, Modal} from "react-bootstrap"
import ErrorText from "@irati/ui/src/ErrorText"
import Input from "@irati/ui/src/FormItem/Input"
import Form from "@irati/ui/src/Form"
import Button from "@irati/ui/src/Button"
import {Firstname, Lastname, Email, ExternalID} from "@irati-web/fields/user"
import Picture from "@irati/ui/src/ProfilePicture"
import {Para} from "@irati/ui/src/Labels"
import {User} from "@irati/types"

import {getTeamSchema} from "@irati/admin/helpers/validation/schema"
import {FIRSTNAME, LASTNAME, EMAIL, TEAMS, EXTERNAL_ID} from "@irati/admin/helpers/userCSV"
import PictureWrapper from "./styled/Picture"
import Info from "./styled/Info"
import FailedUser from "./styled/FailedUser"
import Flex from "./styled/Flex"
import MarginRightButton from "./styled/MarginRightButton"
import Trashcan from "./styled/Trashcan"

interface Props extends InjectIntl {
  user: User,
  removeUser: (user: User) => void,
  headers: string[]
}

interface State {
  open: boolean,
  showErrors: boolean
}

class EditFailedUser extends Component<Props, State> {
  state = {
    open: false,
    showErrors: true
  }

  openModal = () => {
    this.setState({open: true})
  }

  hideModal = () => {
    this.setState({open: false})
  }

  remove = () => {
    this.hideModal()
    this.props.removeUser(this.props.user)
  }

  handleChange = (label, value) => {
    this.props.user[label] = value
    this.setState({showErrors: false})
  }

  hasHeader = (header: string) => {
    return this.props.headers.find((test) => test === header)
  }

  render() {
    const {showErrors, open} = this.state
    const {user, formatMessage} = this.props
    const {email, firstName, lastName, teams, externalUserId} = user

    return (
      <FailedUser>
        {!!(this.hasHeader(FIRSTNAME) || this.hasHeader(LASTNAME)) && (
          <PictureWrapper>
            <Picture user={user} regular />
          </PictureWrapper>
        )}
        <Info>
          <Flex>
            <Form>
              <Row>
                {this.hasHeader(FIRSTNAME) && (
                  <Col xs={12} sm={6} md={3}>
                    <Firstname value={firstName} onChange={(value: string) => this.handleChange("firstName", value)} />
                  </Col>
                )}
                {this.hasHeader(LASTNAME) && (
                  <Col xs={12} sm={6} md={3}>
                    <Lastname value={lastName} onChange={(value: string) => this.handleChange("lastName", value)} />
                  </Col>
                )}
                {this.hasHeader(EMAIL) && (
                  <Col xs={12} sm={6} md={3}>
                    <Email value={email} onChange={(value: string) => this.handleChange("email", value)} />
                  </Col>
                )}
                {this.hasHeader(TEAMS) && (
                  <Col xs={12} sm={6} md={3}>
                    <Input
                      label={formatMessage({id: "admin.components.editFailedUser.fields.label.team"})}
                      type="text"
                      name="team"
                      value={teams}
                      onChange={(value: string) => this.handleChange("teams", value)}
                      validation={getTeamSchema()} />
                  </Col>
                )}
                {this.hasHeader(EXTERNAL_ID) && (
                  <Col xs={12} sm={6} md={3}>
                    <ExternalID value={externalUserId} onChange={(value: string) => this.handleChange("externalUserId", value)} />
                  </Col>
                )}
                <Trashcan onClick={this.openModal} />
              </Row>
              {showErrors &&
                user.error.map((error: string, i: number) => (
                  <Row key={i}>
                    <Col xs={12}>
                      <ErrorText>
                        <FormattedMessage id={error} />
                      </ErrorText>
                    </Col>
                  </Row>
                ))}
            </Form>
            <Modal className="remove-user" show={open} onHide={() => this.setState({open: false})}>
              <Modal.Body>
                <Para flush>
                  <FormattedMessage
                    id="admin.components.editFailedUser.modal.body.text"
                    values={{firstname: user.firstName || user.email}} />
                </Para>
              </Modal.Body>
              <Modal.Footer>
                <MarginRightButton primary onClick={this.remove}>
                  <FormattedMessage id="admin.components.editFailedUser.button.yes" />
                </MarginRightButton>
                <Button onClick={this.hideModal}>
                  <FormattedMessage id="admin.components.editFailedUser.button.no" />
                </Button>
              </Modal.Footer>
            </Modal>
          </Flex>
        </Info>
      </FailedUser>
    )
  }
}

export default injectIntl(EditFailedUser)
